import React from 'react'
import AuthGate from 'components/gate/auth/'
import Loader from 'components/loader/'
import Box from '@material-ui/core/Box'
import { Redirect, useLocation } from 'react-router-dom'
import * as Constants from 'application/constants'

const AuthedLayout = ({ children }) => {
  const location = useLocation()

  return (
    <AuthGate fallback={<Redirect to={{ pathname: Constants.PATH.LOGIN, state: { from: location } }} />} loader={<Loader/>}>
      <Box display="flex" width="100%" height="100%">{children}</Box>
    </AuthGate>
  )
}

export default AuthedLayout